import React, {PropsWithChildren} from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {generateTypeScale, majorSecondScaleFN} from "@pg-design/text-module";

import {IReelSize} from "../../../types/IReelSize";

interface IProps extends PropsWithChildren {
    size: IReelSize;
    className?: string;
}

export const ReelDescription = (props: IProps) => {
    return (
        <Text size={props.size} className={props.className}>
            {props.children}
        </Text>
    );
};

const getFontSize = (index: number, variant: keyof ReturnType<typeof generateTypeScale>) => generateTypeScale(majorSecondScaleFN(index))[variant];

const getFontStyleBySize = (size: IReelSize) => {
    switch (size) {
        case "S":
            return {
                fontSize: getFontSize(1.2, 300),
                lineHeight: "1.2rem",
                fontWeight: 400
            };
        case "M":
            return {
                fontSize: getFontSize(1.4, 300),
                lineHeight: "1.6rem",
                fontWeight: 400
            };
        case "L":
            return {
                fontSize: getFontSize(1.4, 500),
                lineHeight: "2.4rem",
                fontWeight: 400
            };
        case "XL":
            return {
                fontSize: getFontSize(1.2, 800),
                lineHeight: "2.4rem",
                fontWeight: 500
            };
    }
};

const Text = styled.div<{size: IReelSize}>`
    color: #fff;
    text-shadow: 0 1px 1px #000;
    font-family: ${({theme}) => theme.text.family.primary};
    font-style: normal;
    ${({size}) => {
        const {fontSize, lineHeight, fontWeight} = getFontStyleBySize(size);

        return css`
            font-size: ${fontSize};
            line-height: ${lineHeight};
            font-weight: ${fontWeight};
        `;
    }};
`;
import React, {PropsWithChildren} from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {generateTypeScale, majorSecondScaleFN} from "@pg-design/text-module";

import {IReelSize} from "../../../types/IReelSize";

interface IProps extends PropsWithChildren {
    size: IReelSize;
    className?: string;
}

export const ReelDescription = (props: IProps) => {
    return (
        <Text size={props.size} className={props.className}>
            {props.children}
        </Text>
    );
};

const getFontSize = (index: number, variant: keyof ReturnType<typeof generateTypeScale>) => generateTypeScale(majorSecondScaleFN(index))[variant];

const getFontStyleBySize = (size: IReelSize) => {
    switch (size) {
        case "S":
            return {
                fontSize: getFontSize(1.2, 300),
                lineHeight: "1.2rem",
                fontWeight: 400
            };
        case "M":
            return {
                fontSize: getFontSize(1.4, 300),
                lineHeight: "1.6rem",
                fontWeight: 400
            };
        case "L":
            return {
                fontSize: getFontSize(1.4, 500),
                lineHeight: "2.4rem",
                fontWeight: 400
            };
        case "XL":
            return {
                fontSize: getFontSize(1.2, 800),
                lineHeight: "2.4rem",
                fontWeight: 500
            };
    }
};

const Text = styled.div<{size: IReelSize}>`
    color: #fff;
    text-shadow: 0 1px 1px #000;
    font-family: ${({theme}) => theme.text.family.primary};
    font-style: normal;
    ${({size}) => {
        const {fontSize, lineHeight, fontWeight} = getFontStyleBySize(size);

        return css`
            font-size: ${fontSize};
            line-height: ${lineHeight};
            font-weight: ${fontWeight};
        `;
    }};
`;
